import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=2de90cd0&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=2de90cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de90cd0",
  null
  
)

export default component.exports